import React, { useState, useMemo, useCallback, useEffect } from "react";
import Select from "react-select";
import toast from "react-hot-toast";
import { callDeleteApi, callGetApi, callPostApi, callPutApi } from "api/ApiCaller";
import {
    Activate_Item_List_Item_PUT,
    Delete_Item_Deleted_List_Item_DELETE,
    Get_Condiment_List_POST,
    Get_Cuisine_List_Item_Key_Value_GET,
    Get_Customization_List_POST,
    GET_Ingredient_List_POST,
    GET_Item_Deleted_List_POST,
    Get_Item_key_List_GET,
    Get_Item_List_Item_GET,
    GET_Item_List_POST,
    Inactivate_Item_List_Item_PUT,
    Revive_Item_List_Item_PUT,
} from "api/ApiConst";
import { API_SUCCESS } from "api/ResponseCodes";
import dateUtilities from "utils/DateUtilities.jsx";
import PaginationDataTable from "components/common/PaginationDataTable";
import ItemAddEdit from "./ItemAddEdit";
import { getImageSrcViaRefId } from "utils/UserUtils";
import { Print } from "utils/SvgComponent";
import ViewPdf from "../view-pdf/ViewPdf";
import { useLocation } from "react-router-dom";
import CustomizationAddEdit from "./CustomizationAddEdit";
import CondimentAddEdit from "./CondimentAddEdit";
import { useSelector } from "react-redux";

const customStyles = {
    menu: (provided) => ({
        ...provided,
        left: 0,
        right: "auto",
        zIndex: 9999,
    }),
    option: (provided) => ({
        ...provided,
        textAlign: "left",
    }),
    singleValue: (provided) => ({
        ...provided,
        textAlign: "left",
    }),
    valueContainer: (provided) => ({
        ...provided,
        justifyContent: "flex-start",
    }),
};



const ItemMaster = () => {
    const location = useLocation();
    const { user } = useSelector((state) => state.user);
    let urlRecipeType = location.pathname.split("/")[1];
    let recipeType = urlRecipeType.toUpperCase().replace(/-/g, "_")
    const [record, setRecord] = useState(null);
    const [viewDeletedList, setViewDeletedList] = useState(false);
    const [refreshFlag, setRefreshFlag] = useState(0);
    const [showModal, setShowModal] = useState(null);
    const [recordID, setRecordID] = useState(null);
    const [cuisineKeyPairList, setCuisineKeyPairList] = useState([]);
    const [indregientKeyPairList, setIndregientKeyPairList] = useState([]);
    const [showPdfModal, setShowPdfModal] = useState(false);
    const [condimentsKeyPairList, setCondimentsKeyPairList] = useState([]);
    const [itemKeyPairList, setItemKeyPairList] = useState([]);
    const [customizationKeyPairList, setCustomizationKeyPairList] = useState([]);
    const [cuisineType, setCuisineType] = useState("All");
    const [filterValueList, setFilterValueList] = useState([]);


    useEffect(() => {
        if (!showModal && !showPdfModal) {
            setRecordID(null);
        }
    }, [showModal, showPdfModal]);

    useEffect(() => {
        getCuisineKeyPairList();
        getIngredientKeyPairList();
        getCondimentList();
        getCustomizationList();
        if (recipeType === "ITEM_RECIPE") {
            getItemKeyValueList();
        };
        // getUOMKeyPairList();
    }, []);

    // Get Cusine Key Pair List
    const getCuisineKeyPairList = () => {
        callGetApi(
            "loader",
            Get_Cuisine_List_Item_Key_Value_GET.replace("{uuid}", recordID),
            {},
            (res) => {
                if (res.errorCode === API_SUCCESS) {
                    setCuisineKeyPairList(res.responsePacket);
                    setFilterValueList([{
                        label: "All", value: "All"
                    }, ...res.responsePacket || []]);
                }
            }
        );
    };

    // Get Brand Key Pair List
    // const getBrandKeyPairList = () => {
    //     callGetApi(
    //         "loader",
    //         Get_Brand_List_Item_Key_Value_GET.replace("{uuid}", recordID),
    //         {},
    //         (res) => {
    //             if (res.errorCode === API_SUCCESS) {
    //                 setBrandKeyPairList(res.responsePacket);
    //             }
    //         }
    //     );
    // };

    // Get Ingredient Key Pair List
    const getIngredientKeyPairList = () => {
        callPostApi(
            "loader",
            GET_Ingredient_List_POST,
            {},
            {},
            (response) => {
                const res = response.responsePacket;
                if (response.errorCode === API_SUCCESS) {
                    const newArr = res.map((item) => {
                        if (!item?.otherUnits) {
                            return;
                        }
                        const _otherUnits = item?.otherUnits.map((value, i) => (i === 0 ? {
                            label: value.unit,
                            value: value.unit,
                            key: "openUnit"
                        } : {
                            label: value.unit,
                            value: value.unit,
                        }))
                        return {
                            label: item.itemName,
                            value: item.itemUuid,
                            tag: _otherUnits
                        }
                        // }
                        // if(item.fractionalUnit) {
                        //     return {
                        //         label: item.itemName,
                        //         value: item.itemUuid,
                        //         tag: [
                        //             { label: item.packUnit, value: item.packUnit, key: "packUnit"},
                        //             { label: item.openUnit, value: item.openUnit, key: "openUnit"},
                        //             { label: item.fractionalUnit, value: item.fractionalUnit, key: "fractionalUnit"},
                        //         ]
                        //     }
                        // } else {
                        //     return {
                        //         label: item.itemName,
                        //         value: item.itemUuid,
                        //         tag: [
                        //             { label: item.packUnit, value: item.packUnit, key: "packUnit"},
                        //             { label: item.openUnit, value: item.openUnit, key: "openUnit"},
                        //         ]
                        //     }
                        // }
                    })
                    const _newArr = newArr.filter((item) => item);
                    setIndregientKeyPairList(_newArr);
                }
            }
        );
    };

    const getCondimentList = () => {
        callPostApi("loader", Get_Condiment_List_POST, {}, {}, (response) => {
            if (response.errorCode !== API_SUCCESS) return
            const res = response?.responsePacket
            let condimentList = Array.isArray(res) && res.length > 0
                ? res.map((item) => ({
                    key: item?.recipeReferenceId,
                    value: item?.condimentId,
                    label: item?.title

                })) : []

            setCondimentsKeyPairList(condimentList)
        })
    };

    const getCustomizationList = () => {
        callPostApi("loader", Get_Customization_List_POST, {}, {}, (response) => {
            if (response.errorCode !== API_SUCCESS) return
            const res = response?.responsePacket
            let customizationList = Array.isArray(res) && res.length > 0 ? res.map((item) => {
                const option = JSON.parse(item?.customizationOptionJson || []);
                return {
                    value: item?.itemCustomizationId,
                    label: item?.title,
                    key: option?.map((item) => ({
                        id: item?.id,
                        recipeReferenceId: item?.recipeReferenceId,
                        name: item?.name,
                    })),
                }
            }) : []
            setCustomizationKeyPairList(customizationList)
        })
    };
    // get Item key value List
    const getItemKeyValueList = () => {
        callGetApi("loader", Get_Item_key_List_GET, {}, (response) => {
            if (response.errorCode !== API_SUCCESS) return
            const res = response?.responsePacket
            setItemKeyPairList(res)
        })
    }

    const handleRefresh = useCallback(() => {
        setRefreshFlag(refreshFlag + 1);
    }, [refreshFlag]);

    const columns = useMemo(
        () => [
            {
                id: "status",
                name: "",
                cell: (row) => (
                    <div>
                        <div
                            className={
                                row.active
                                    ? "active-container"
                                    : "inactive-container"
                            }
                        />
                    </div>
                ),
                sortable: false,
                width: "60px",
            },
            {
                id: "cuisineTitle",
                name: "Cuisine",
                selector: (row) => row.cuisineTitle,
                sortable: true,
                reorder: true,
            },
            {
                id: "title",
                name: "Title",
                selector: (row) => row.title,
                sortable: true,
                reorder: true,
            },
            {
                id: "description",
                name: "Description",
                selector: (row) => row.description,
                sortable: true,
                reorder: true,
            },

            {
                id: "gameIconRefId",
                name: "Image",
                center: true,
                selector: (row) => (
                    <div className="table-img">
                        <img
                            src={getImageSrcViaRefId(row.itemImageRefIds[0])}
                            alt={row.gameTitle}
                        />
                    </div>
                ),
                sortable: false,
            },
            {
                id: "createdAtTimeStamp",
                name: "Created At",
                selector: (row) =>
                    dateUtilities.formattedDate(
                        row.createdAtTimeStamp,
                        "dd-MM-yyyy hh:mm aa"
                    ),
                sortable: true,
                reorder: true,
            },
            {
                id: "modifiedAtTimeStamp",
                name: "Modified At",
                selector: (row) =>
                    dateUtilities.formattedDate(
                        row.modifiedAtTimeStamp,
                        "dd-MM-yyyy hh:mm aa"
                    ),
                sortable: true,
                reorder: true,
            },
            {
                id: "action",
                name: "Action",
                style: {
                    justifyContent: "flex-start",
                },
                cell: (row) => getActionEvents(row),
            },
        ],
        [handleRefresh, viewDeletedList]
    );

    const getActionEvents = (row) => {
        return (
            <div className="d-flex gap-3">
                <div className="dropdown">
                    <button
                        className="btn btn-primary btn-sm dropdown-toggle"
                        type="button"
                        id="actionBtn"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        Action button
                    </button>
                    {viewDeletedList ? (
                        <ul className="dropdown-menu" aria-labelledby="actionBtn">
                            <li onClick={() => handleReviveEvent(row.uuid)}>
                                Revive
                            </li>
                        </ul>
                    ) : (
                        <ul className="dropdown-menu" aria-labelledby="actionBtn">
                            <li onClick={() => handleEdit(row.uuid)}>Edit</li>
                            <li
                                onClick={() => {
                                    row.active
                                        ? handleInactiveEvent(row.uuid)
                                        : handleActiveEvent(row.uuid);
                                }}
                            >
                                {row.active ? "Inactive" : "Active"}
                            </li>
                            {(user && user.userType !== "ADMIN_ASSISTANT") && <li onClick={() => handleDeleteEvent(row.uuid)}>
                                Delete
                            </li>}
                        </ul>
                    )}
                </div>
                <div onClick={() => handleShowPdfModal(row.uuid)} className="btn btn-primary rounded py-0 px-1 fd-6" >
                    <Print width="24" fill="white" />
                </div>
            </div>
        );
    };

    const handleActiveEvent = (uuid) => {
        callPutApi(
            "loader",
            Activate_Item_List_Item_PUT.replace("{uuid}", uuid),
            record,
            {},
            (res) => {
                if (res.errorCode === API_SUCCESS) {
                    toast.success("Activated Item Successfully");
                    handleRefresh();
                }
            }
        );
    };
    const handleInactiveEvent = (uuid) => {
        callPutApi(
            "loader",
            Inactivate_Item_List_Item_PUT.replace("{uuid}", uuid),
            record,
            {},
            (res) => {
                if (res.errorCode === API_SUCCESS) {
                    toast.success("Deactivated Item Successfully");
                    handleRefresh();
                }
            }
        );
    };

    const handleDeleteEvent = (uuid) => {
        callDeleteApi(
            "loader",
            Delete_Item_Deleted_List_Item_DELETE.replace("{uuid}", uuid),
            {},
            (response) => {
                if (response.errorCode === API_SUCCESS) {
                    //toast.success(response.message);
                    toast.success("Delete Item Successfully");
                    handleRefresh();
                }
            }
        );
    };

    const handleReviveEvent = (uuid) => {
        getRecordItems(uuid);
        callPutApi(
            "loader",
            Revive_Item_List_Item_PUT.replace("{uuid}", uuid),
            record,
            {},
            (res) => {
                if (res.errorCode === API_SUCCESS) {
                    toast.success("Revive Item Successfully");
                    handleRefresh();
                }
            }
        );
    };

    const getRecordItems = (uuid) => {
        callGetApi(
            "loader",
            Get_Item_List_Item_GET.replace("{uuid}", uuid),
            {},
            (res) => {
                setRecord(res.responsePacket);
            }
        );
    };

    const handleShowPdfModal = (uuid) => {
        setShowPdfModal(true);
        setRecordID(uuid);
    }

    const handleEdit = (uuid) => {
        setRecordID(uuid);
        setShowModal(true);
    };

    const handleAddEvent = () => {
        setShowModal(true);
    };

    return (
        <>
            <div className="container-fluid">
                <div className="card shadow mt-3">

                    <div className="text-end p-3 border-bottom d-flex align-items-center justify-content-between">
                        <div className="page-title-box">
                            <h4 className="mb-sm-0 font-size-18">
                                {recipeType?.replaceAll("_", " ")}
                            </h4>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                            <div style={{ minWidth: "150px" }}>
                                <Select
                                    options={filterValueList}
                                    value={filterValueList?.find((item) => item.key === cuisineType) || { key: "All", label: "All" }}
                                    styles={customStyles}
                                    menuPlacement="auto"
                                    onChange={(e) => {
                                        setCuisineType(e.value);
                                        setRefreshFlag(prev => prev + 1);
                                    }}

                                />
                            </div>

                            {!viewDeletedList && (
                                <button
                                    className="btn btn-primary"
                                    onClick={() => handleAddEvent()}
                                >
                                    Add
                                </button>
                            )}

                            <div className="form-check btn btn-primary mb-0">
                                <input
                                    className="form-check-input ms-0"
                                    type="checkbox"
                                    onChange={() => setViewDeletedList(!viewDeletedList)}
                                    id="flexCheckDefault"
                                />
                                <label
                                    className="form-check-label text-light ps-2"
                                    htmlFor="flexCheckDefault"
                                >
                                    Delete List
                                </label>
                            </div>
                        </div>
                    </div>

                    <PaginationDataTable
                        paginationUrl={
                            viewDeletedList
                                ? GET_Item_Deleted_List_POST.replaceAll("{cuisineId}", cuisineType).replaceAll("{recipeType}", recipeType)
                                : GET_Item_List_POST.replaceAll("{cuisineId}", cuisineType).replaceAll("{recipeType}", recipeType)
                        }
                        serverSidePagination={true}
                        search={true}
                        pagination={false}
                        columns={columns}
                        defaultSortFieldId="cuisineTitle"
                        defaultSortDirection="asc"

                    />
                </div>
            </div>
            {(showModal && recipeType === "ITEM_RECIPE") && (
                <ItemAddEdit
                    show={showModal}
                    hideModal={() => setShowModal(false)}
                    recordID={recordID}
                    handleRefresh={handleRefresh}
                    cuisineKeyPairList={cuisineKeyPairList}
                    indregientKeyPairList={indregientKeyPairList}
                    condimentsKeyPairList={condimentsKeyPairList}
                    itemKeyPairList={itemKeyPairList}
                    customizationKeyPairList={customizationKeyPairList}
                />
            )}
            {(showModal && recipeType === "CUSTOMIZATION_RECIPE") && (
                <CustomizationAddEdit
                    show={showModal}
                    hideModal={() => setShowModal(false)}
                    recordID={recordID}
                    handleRefresh={handleRefresh}
                    cuisineKeyPairList={cuisineKeyPairList}
                    indregientKeyPairList={indregientKeyPairList}
                />
            )}
            {(showModal && recipeType === "CONDIMENT_RECIPE") && (
                <CondimentAddEdit
                    show={showModal}
                    hideModal={() => setShowModal(false)}
                    recordID={recordID}
                    handleRefresh={handleRefresh}
                    cuisineKeyPairList={cuisineKeyPairList}
                    indregientKeyPairList={indregientKeyPairList}
                />
            )}
            <ViewPdf recordID={recordID} showPdfModal={showPdfModal} hideModal={() => setShowPdfModal(false)} />
        </>
    );
};

export default ItemMaster;
